import { DocumentWorkflowTemplateType, SignatureType } from '@dealstack/shared/lib/generated';

type GetSignatureTypeArgs = {
	type: DocumentWorkflowTemplateType;
	formSignatureType: SignatureType;
	/**
	 * When true, returns undefined for non-signing document types (FORM_INPUT, READ_ONLY)
	 * instead of the default SignatureType.REVIEW. Use this in update flows to avoid
	 * sending a signatureType for templates that have no signing config.
	 */
	omitForNonSigning?: boolean;
};

export function getSignatureType(
	args: GetSignatureTypeArgs & { omitForNonSigning: true }
): SignatureType | undefined;
export function getSignatureType(
	args: GetSignatureTypeArgs & { omitForNonSigning?: false }
): SignatureType;
export function getSignatureType({
	type,
	formSignatureType,
	omitForNonSigning = false,
}: GetSignatureTypeArgs): SignatureType | undefined {
	if (type === DocumentWorkflowTemplateType.SIGNATURE_REQUIRED) {
		return formSignatureType;
	}
	if (type === DocumentWorkflowTemplateType.SIGNABLE_FORM) {
		return SignatureType.ELECTRONIC;
	}
	return omitForNonSigning ? undefined : SignatureType.REVIEW;
}
